import { render, staticRenderFns } from "./pdf-viewer.vue?vue&type=template&id=d8e543a0&scoped=true"
import script from "./pdf-viewer.vue?vue&type=script&lang=ts"
export * from "./pdf-viewer.vue?vue&type=script&lang=ts"
import style0 from "./pdf-viewer.vue?vue&type=style&index=0&id=d8e543a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e543a0",
  null
  
)

export default component.exports